import { render } from "./MyResourcesNav.vue?vue&type=template&id=7e9bc277"
import script from "./MyResourcesNav.vue?vue&type=script&lang=js"
export * from "./MyResourcesNav.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__